import { BrowserStorage, StorageValue } from './storage.types';

const BNC_DOMAIN = '.bnc.ca';

const getCookieDomain = (): string | null => {
  const hostname = window.location.hostname;
  if (hostname === 'localhost') return null;
  return hostname.endsWith(BNC_DOMAIN) ? BNC_DOMAIN : null;
};

const buildCookieAttributes = (expires?: Date): string => {
  const attributes = ['Path=/', 'SameSite=Lax'];
  const isSecure = window.location.protocol === 'https:';

  if (isSecure) {
    attributes.push('Secure');
  }

  const domain = getCookieDomain();
  if (domain) {
    attributes.push(`Domain=${domain}`);
  }

  if (expires) {
    attributes.push(`Expires=${expires.toUTCString()}`);
  }

  return attributes.join('; ');
};

export const cookieStorage: BrowserStorage = {
  getItem(key: string): StorageValue {
    const cookies = document.cookie ? document.cookie.split(';') : [];
    const cookie = cookies.find((entry) => entry.trim().startsWith(`${key}=`));
    return cookie ? decodeURIComponent(cookie.split('=').slice(1).join('=')) : null;
  },
  setItem(key: string, value: string, expires?: Date): void {
    document.cookie = `${key}=${encodeURIComponent(value)}; ${buildCookieAttributes(expires)}`;
  },
  removeItem(key: string): void {
    document.cookie = `${key}=; ${buildCookieAttributes(new Date(0))}`;
  },
};
